import React from 'react'
import {formatCents, gaEvent} from 'shared'

export class Numbers extends React.Component {
  render() {
    const hasTarget = !!this.props.fundraisingEvent.requested_amount_in_cents

    return <div className="fundraising-events-show-numbers container has-generic-scroll-down-button p-b">
      <div className="row text-center">
        <div className={`offset-md-5 col-md-14 ${hasTarget ? 'with-target' : ''}`}>
          <ul className="list-unstyled">
            <LeftSide cents={this.props.fundraisingEvent.donated_amount_in_cents} sponsoringLabel={this.props.donatedAmountCaption} />
            <RightSide {...this.props} />
            <Progress percentage={this.props.fundraisingEvent.progress_percentage || 0} hasTarget={hasTarget} />

            <li className="about"><a onClick={(event) => {
              event.preventDefault()
              gaEvent('engagement', 'click go_to_description')
              document.querySelector('#description').scrollIntoView({behavior: 'smooth'})
            }} href="#description">{I18n.t('fundraising_events.show.numbers.goto_description_link')}</a></li>

            <li className="share-button"><a onClick={(event) => {
              event.preventDefault()
              gaEvent('engagement', 'click go_to_share')
              document.querySelector('#share').scrollIntoView({behavior: 'smooth'})
            }} href="#share">{I18n.t('fundraising_events.show.numbers.share_link')}</a></li>
          </ul>
        </div>
      </div>
    </div>
  }
}

const LeftSide = ({cents, sponsoringLabel}) => {
  return <li className="left-side">
    <div className="number">{formatCents(cents)}</div>
    <div className="legend">{sponsoringLabel || I18n.t('fundraising_events.show.numbers.donated_amount_label')}</div>
  </li>
}

const RightSide = (props) => {
  const requestedCents = props.fundraisingEvent.requested_amount_in_cents
  const donationsCount = props.fundraisingEvent.donations_count
  let number, legend

  if (parseInt(props.sponsoringAmountCents, 10) > 0) {
    number = formatCents(props.sponsoringAmountCents)
    legend = props.sponsoringAmountCaption
  } else if (parseInt(requestedCents, 10) > 0) {
    number = formatCents(requestedCents)
    legend = I18n.t('fundraising_events.show.numbers.target_amount_label')
  } else {
    number = donationsCount
    legend = I18n.t('fundraising_events.show.numbers.donation_count_label', {count: donationsCount})
  }
  return <li className="right-side">
    <div className="number">{number}</div>
    <div className="legend">{legend}</div>
  </li>
}

const Progress = ({percentage, hasTarget}) => {
  if (!hasTarget) return <li className='separator'><hr /></li>
  return <li className="progress-bar-container">
    <div className="progress generic-progress-bar m-b-sm">
      <div className="bar" style={{width: `${percentage}%`}}></div>
    </div>
  </li>
}
